import { Suspense, useMemo } from "react";
import { useLocalSearchParams } from "expo-router";
import { MatchCase } from "@ptsd/uikit";
import { useMedia } from "tamagui";

import { api } from "~/utils/api";
import {
  constructDynamicsText,
  getSliceDynamicsStatus,
} from "~/utils/construct-dynamics";
import { resolveSliceStatus } from "~/utils/get-status";
import { LoadingScreen } from "~/component/blocks";
import {
  ComposedTextSlices,
  ComposedTextSlicesMobile,
  SliceDynamics,
  SliceScales,
  SliceScalesMobile,
  SlicesDynmaicsChartMobile,
} from "~/component/feature";
import { useConstructScales } from "~/hooks";

const Slice = () => {
  return (
    <Suspense fallback={<LoadingScreen height={"70dvh"} />}>
      <SliceBody />
    </Suspense>
  );
};

export default Slice;

const SliceBody = () => {
  const slug = useLocalSearchParams().slug;
  const type = String(slug);
  const { sm } = useMedia();

  const [data] = api.slices.getResults.useSuspenseQuery({ type });

  const composedText = useMemo(
    () => ({
      type,
      description: { md: data.main.text, mdDomain: "hmt" },
      image: "/cards/hmt.png",
      title: data.main.title,
      score: data.main.score,
      state: resolveSliceStatus(String(slug), data.main.level),
      dynamics: {
        state: getSliceDynamicsStatus(data.main.dynamic) ?? "",
        description: data.main.name,
        text: constructDynamicsText(data.main.dynamic.diff) ?? "",
      },
    }),
    [data, slug, type],
  );

  const scales = useConstructScales(data.scales);

  return (
    <MatchCase value={sm}>
      {(Case) => (
        <>
          <Case condition={false}>
            <ComposedTextSlices {...composedText} />
            <SliceDynamics data={data} />
            <SliceScales scales={scales} />
          </Case>
          <Case condition={true}>
            <ComposedTextSlicesMobile {...composedText} />
            <SlicesDynmaicsChartMobile data={data} />
            <SliceScalesMobile scales={scales} />
          </Case>
        </>
      )}
    </MatchCase>
  );
};
